var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNavLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 206.598,
    height: 32.206,
    viewBox: "0 0 206.598 32.206",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(3484 3676)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-3309.638 -3676)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M325.222,2.091h0C315.02,5.39,309.605-2.432,299.4.866q-2.652,6.159-5.3,12.332c10.189-3.285,15.617,4.51,25.805,1.239l-7.46,17.774h.891l13-29.647Z",
    transform: "translate(-294.1 -0.036)",
    fill: "#10312b",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M376.91,26.832a4.207,4.207,0,0,0,2.213-.431,4.551,4.551,0,0,1-.028,2c.223.028.459.042.7.056.891-5.943-6.347-6.959-6.347-6.959s5.512.07,6.625,4.12a2.807,2.807,0,0,0,.32-2.631c-.724-2.185-3.7-2.8-6.18-3.076a4.817,4.817,0,0,1-3.4-1.615C370.2,24.563,374.223,26.707,376.91,26.832Z",
    transform: "translate(-360.082 -15.758)",
    fill: "#a2d45e",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-3484 -3676)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.041 0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.743,173.421l-3.5-5.972c-.165,0-.412.041-.741.041H3.971v5.93H.1V153.2H8.543a9.082,9.082,0,0,1,6.054,1.812,6.311,6.311,0,0,1,2.142,5.148,6.094,6.094,0,0,1-1.03,4.036,6.488,6.488,0,0,1-3.006,2.512l4.448,6.713Zm-8.772-9.349H8.543a5.115,5.115,0,0,0,3.336-.947,3.388,3.388,0,0,0,1.153-2.842,3.221,3.221,0,0,0-1.153-2.759,5.273,5.273,0,0,0-3.336-.906H3.971Z",
    transform: "translate(-0.1 -153.2)",
    fill: "#10312b"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51,153.2h3.871v20.221H51Z",
    transform: "translate(-30.037 -153.2)",
    fill: "#10312b"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67,153.2h4.16l5.93,15.9L83.1,153.2H87.1l-8.072,20.221H75.031Z",
    transform: "translate(-39.448 -153.2)",
    fill: "#10312b"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.5,153.2h14.826v3.377H126.371v4.983h9.8v3.377h-9.8V170h11.284v3.377H122.5V153.2Z",
    transform: "translate(-72.091 -153.2)",
    fill: "#10312b"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181.985,173.421l-3.5-5.972c-.165,0-.412.041-.741.041h-4.571v5.93H169.3V153.2h8.443a9.082,9.082,0,0,1,6.054,1.812,6.311,6.311,0,0,1,2.142,5.148,6.094,6.094,0,0,1-1.03,4.036,6.488,6.488,0,0,1-3.006,2.512l4.448,6.713h-4.366Zm-8.772-9.349h4.571a5.115,5.115,0,0,0,3.336-.947,3.388,3.388,0,0,0,1.153-2.842,3.221,3.221,0,0,0-1.153-2.759,5.273,5.273,0,0,0-3.336-.906h-4.571Z",
    transform: "translate(-99.617 -153.2)",
    fill: "#10312b"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M234.567,155.012a6.412,6.412,0,0,1,2.1,5.148,7.072,7.072,0,0,1-2.1,5.4,8.455,8.455,0,0,1-5.889,1.936h-4.407v5.93H220.4V153.2h8.278A8.833,8.833,0,0,1,234.567,155.012Zm-2.759,8.072a3.388,3.388,0,0,0,1.153-2.842,3.221,3.221,0,0,0-1.153-2.759,5.323,5.323,0,0,0-3.377-.906h-4.2v7.5h4.2a5.083,5.083,0,0,0,3.377-.988Z",
    transform: "translate(-129.672 -153.2)",
    fill: "#10312b"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M276.121,173.421l-1.771-4.283h-9.884l-1.771,4.283H258.7l8.855-20.221h3.995l8.772,20.221ZM265.866,165.8h7.125l-3.542-8.484Z",
    transform: "translate(-152.198 -153.2)",
    fill: "#10312b"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M330.285,173.421l-3.5-5.972c-.165,0-.412.041-.741.041h-4.571v5.93H317.6V153.2h8.443a9.082,9.082,0,0,1,6.054,1.812,6.311,6.311,0,0,1,2.142,5.148,6.094,6.094,0,0,1-1.03,4.036,6.488,6.488,0,0,1-3.006,2.512l4.448,6.713Zm-8.813-9.349h4.571a5.115,5.115,0,0,0,3.336-.947,3.388,3.388,0,0,0,1.153-2.842,3.221,3.221,0,0,0-1.153-2.759,5.273,5.273,0,0,0-3.336-.906h-4.571Z",
    transform: "translate(-186.841 -153.2)",
    fill: "#10312b"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M386.639,173.48h-4.654l-6.342-8.649-3.171,3.5v5.189H368.6V153.3h3.871v10.09l9.143-10.09h4.571l-7.784,8.566,8.237,11.614Z",
    transform: "translate(-216.837 -153.259)",
    fill: "#10312b"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 27.305)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.459,220.153a1.523,1.523,0,0,1,.494,1.194,1.706,1.706,0,0,1-.494,1.277,1.937,1.937,0,0,1-1.4.494H1.236v1.277H0V219.7H2.059A2.116,2.116,0,0,1,3.459,220.153Zm-.865,1.812a.8.8,0,0,0,0-1.071.805.805,0,0,0-.577-.165H1.236v1.441h.782A.893.893,0,0,0,2.595,221.965Z",
    transform: "translate(0 -219.618)",
    fill: "#10312b"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.842,224.395l-.7-1.277h-.906v1.277H32V219.7h2.1a2.149,2.149,0,0,1,1.441.412,1.523,1.523,0,0,1,.494,1.194,1.628,1.628,0,0,1-.206.906,1.485,1.485,0,0,1-.618.618l.988,1.524H34.842Zm-1.606-2.265h.906a.815.815,0,0,0,.577-.206.8.8,0,0,0,0-1.071.805.805,0,0,0-.577-.165h-.906Z",
    transform: "translate(-18.821 -219.618)",
    fill: "#10312b"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.889,219.929a2.289,2.289,0,0,1,.906.865,2.481,2.481,0,0,1,0,2.471,2.289,2.289,0,0,1-.906.865,2.638,2.638,0,0,1-2.553,0,2.289,2.289,0,0,1-.906-.865,2.481,2.481,0,0,1,0-2.471,2.289,2.289,0,0,1,.906-.865,2.675,2.675,0,0,1,1.277-.329A2.368,2.368,0,0,1,67.889,219.929Zm-1.936.865a1.048,1.048,0,0,0-.453.494,1.354,1.354,0,0,0-.165.7,1.047,1.047,0,0,0,.165.7,2.689,2.689,0,0,0,.453.494,1.208,1.208,0,0,0,.659.165.993.993,0,0,0,.618-.165,1.309,1.309,0,0,0,.453-.494,1.354,1.354,0,0,0,.165-.7,1.047,1.047,0,0,0-.165-.7,1.757,1.757,0,0,0-.453-.494,1.163,1.163,0,0,0-.618-.165A1.939,1.939,0,0,0,65.953,220.794Z",
    transform: "translate(-37.701 -219.559)",
    fill: "#10312b"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.359,220.094a1.523,1.523,0,0,1,.494,1.194,1.706,1.706,0,0,1-.494,1.277,2.04,2.04,0,0,1-1.4.453h-.824v1.277H98.9V219.6h2.059a2.562,2.562,0,0,1,1.4.494Zm-.865,1.812a.8.8,0,0,0,0-1.071.805.805,0,0,0-.577-.165h-.782v1.441h.782A.815.815,0,0,0,101.495,221.906Z",
    transform: "translate(-58.169 -219.559)",
    fill: "#10312b"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131,219.8h3.707v.988h-2.471v.865h2.224v.988h-2.224v.865h2.553v.988H131Z",
    transform: "translate(-77.049 -219.676)",
    fill: "#10312b"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.842,224.395l-.7-1.277h-.906v1.277H163V219.7h2.1a2.149,2.149,0,0,1,1.441.412,1.523,1.523,0,0,1,.494,1.194,1.628,1.628,0,0,1-.206.906,1.485,1.485,0,0,1-.618.618l.988,1.524h-1.359Zm-1.565-2.265h.906a.815.815,0,0,0,.577-.206.8.8,0,0,0,0-1.071.805.805,0,0,0-.577-.165h-.906Z",
    transform: "translate(-95.87 -219.618)",
    fill: "#10312b"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M194.741,219.8h3.995v.988h-1.4v3.665H196.1v-3.665h-1.4V219.8h0Z",
    transform: "translate(-114.515 -219.676)",
    fill: "#10312b"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M226.8,219.8h1.236v4.695H226.8Z",
    transform: "translate(-133.395 -219.676)",
    fill: "#10312b"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M253.1,219.8h3.707v.988h-2.471v.865h2.224v.988h-2.224v.865h2.553v.988h-3.748V219.8Z",
    transform: "translate(-148.864 -219.676)",
    fill: "#10312b"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M287.177,220.653a2.78,2.78,0,0,0-.7-.124.823.823,0,0,0-.371.082.309.309,0,0,0,0,.494.663.663,0,0,0,.288.165c.124.041.288.082.494.165.329.082.577.206.824.288a1.337,1.337,0,0,1,.535.412,1.15,1.15,0,0,1,.247.741,1.267,1.267,0,0,1-.247.782,1.637,1.637,0,0,1-.659.494,2.416,2.416,0,0,1-.947.165,4.014,4.014,0,0,1-1.153-.206,2.973,2.973,0,0,1-.988-.577l.494-.947a3.367,3.367,0,0,0,.824.494,2.6,2.6,0,0,0,.865.206.764.764,0,0,0,.412-.082.311.311,0,0,0,.165-.288.249.249,0,0,0-.124-.247.664.664,0,0,0-.288-.165c-.124-.041-.288-.082-.494-.165a2.841,2.841,0,0,1-.783-.288,1.7,1.7,0,0,1-.535-.412,1,1,0,0,1-.206-.741,1.075,1.075,0,0,1,.247-.741,1.638,1.638,0,0,1,.659-.494,2.492,2.492,0,0,1,.988-.165,3.822,3.822,0,0,1,.988.124,2.746,2.746,0,0,1,.865.371l-.453.988C287.712,220.859,287.465,220.736,287.177,220.653Z",
    transform: "translate(-167.332 -219.5)",
    fill: "#10312b"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M341.4,219.8h1.236v3.624h1.977v1.03H341.4Z",
    transform: "translate(-200.798 -219.676)",
    fill: "#10312b"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M369.141,219.8h3.995v.988h-1.4v3.665H370.5v-3.665h-1.4V219.8h0Z",
    transform: "translate(-217.09 -219.676)",
    fill: "#10312b"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M404.436,220.088a2.085,2.085,0,0,1,.865.824,2.481,2.481,0,0,1,0,2.471,1.967,1.967,0,0,1-.906.824,2.7,2.7,0,0,1-1.318.288H401.1V219.8h2.018A2.7,2.7,0,0,1,404.436,220.088Zm-.618,3.212a1.211,1.211,0,0,0,.412-.494,1.94,1.94,0,0,0,.165-.7,1.353,1.353,0,0,0-.165-.7,1.309,1.309,0,0,0-.453-.494,1.208,1.208,0,0,0-.659-.165h-.783v2.718h.824A1.209,1.209,0,0,0,403.818,223.3Z",
    transform: "translate(-235.911 -219.676)",
    fill: "#10312b"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNavLogo);
export default __webpack_public_path__ + "static/media/navLogo.57370fac930fabe23590c8c27454bd50.svg";
export { ForwardRef as ReactComponent };